import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-date-picker",
  templateUrl: "./date-picker.component.html",
  styleUrls: ["./date-picker.component.scss"],
})
export class DatePickerComponent implements OnInit, OnChanges {
  date!: Date;
  hourFormat: string = "12";
  minDate: Date | null = null;

  @Input() enableTimePicker: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() ctrlName: Date | null = null;
  @Input() hostingFrom: string = "";

  @Output() dateSelected = new EventEmitter<Date>();

  ngOnInit(): void {
    this.minDate = !this.enableTimePicker ? new Date() : null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.ctrlName?.currentValue) {
      this.date = changes["ctrlName"].currentValue;
    }
  }

  onDateChange(event: Date) {
    this.dateSelected.emit(event);
  }
}
